export default __webpack_public_path__ + "static/media/attendance_banner.b2483399.png";